import type { Route } from '@angular/router';

export const routes: Route[] = [
  {
    path: 'login',
    loadComponent: () => import('./login.component'),
  },
];

export default routes;
